export default __webpack_public_path__ + "static/download-bb6646a06ebffad84ccad34832cc86f7.svg";